export default __webpack_public_path__ + "static/media/資料集.af79b2ff.svg";